const HEX_RE = /^#[0-9a-fA-F]{6}$/;

export function safeHex(value, fallback = "#8d282a") {
  return HEX_RE.test(value || "") ? value : fallback;
}

export function hexToRgb(hex) {
  const safe = safeHex(hex).slice(1);
  return {
    r: parseInt(safe.slice(0, 2), 16),
    g: parseInt(safe.slice(2, 4), 16),
    b: parseInt(safe.slice(4, 6), 16),
  };
}

export function readableTextColor(hex) {
  const { r, g, b } = hexToRgb(hex);
  const [rs, gs, bs] = [r, g, b].map((v) => {
    const c = v / 255;
    return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
  });
  const luminance = 0.2126 * rs + 0.7152 * gs + 0.0722 * bs;
  return luminance > 0.58 ? "#010101" : "#ffffff";
}

export function brandSecondaryStyle(config = {}, fallback = "#010101") {
  const safeConfig = config || {};
  const backgroundColor = safeHex(safeConfig.secondary_color, fallback);
  return {
    backgroundColor,
    color: readableTextColor(backgroundColor),
  };
}

export function brandStyle(config = {}, fallback = "#8d282a") {
  const safeConfig = config || {};
  const backgroundColor = safeHex(safeConfig.primary_color, fallback);
  return {
    backgroundColor,
    color: readableTextColor(backgroundColor),
  };
}

export function brandSoftStyle(config = {}, fallback = "#8d282a") {
  const safeConfig = config || {};
  const color = safeHex(safeConfig.primary_color, fallback);
  return {
    backgroundColor: `${color}12`,
    borderColor: `${color}26`,
    color,
  };
}

export function focusRingStyle(config = {}, fallback = "#8d282a") {
  const safeConfig = config || {};
  return {
    "--tw-ring-color": `${safeHex(safeConfig.primary_color, fallback)}55`,
  };
}
